import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/shared/store'
import { useFlowDirection } from '@/shared/composables/useFlowDirection'
import { getHomeUrl } from '@/shared/utils/GetHomeUrl'

export const useHomeUrl = () => {
  const { locale } = useI18n()
  const userStore = useUserStore()
  const { isInboundRoute } = useFlowDirection()

  return {
    getHomeUrl: () => getHomeUrl(locale.value, userStore.redirectURL, isInboundRoute),
  }
}
